export default "/assets/4e75ed8189c5a7b6fbf85345a204be29.ttf";